{
  "name": "@aws-sdk/client-s3",
  "description": "AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native",
  "version": "3.1053.0",
  "scripts": {
    "build": "concurrently 'yarn:build:types' 'yarn:build:es' && yarn build:cjs",
    "build:cjs": "node ../../scripts/compilation/inline client-s3",
    "build:es": "tsc -p tsconfig.es.json",
    "build:include:deps": "yarn g:turbo run build -F=\"$npm_package_name\"",
    "build:types": "tsc -p tsconfig.types.json",
    "build:types:downlevel": "downlevel-dts dist-types dist-types/ts3.4",
    "clean": "premove dist-cjs dist-es dist-types tsconfig.cjs.tsbuildinfo tsconfig.es.tsbuildinfo tsconfig.types.tsbuildinfo",
    "extract:docs": "api-extractor run --local",
    "generate:client": "node ../../scripts/generate-clients/single-service --solo s3",
    "test": "yarn g:vitest run",
    "test:browser": "node ./test/browser-build/esbuild && yarn g:vitest run -c vitest.config.browser.mts",
    "test:browser:watch": "node ./test/browser-build/esbuild && yarn g:vitest watch -c vitest.config.browser.mts",
    "test:e2e": "yarn g:vitest run -c vitest.config.e2e.mts && yarn test:browser",
    "test:e2e:watch": "yarn g:vitest watch -c vitest.config.e2e.mts",
    "test:index": "tsc --noEmit ./test/index-types.ts && node ./test/index-objects.spec.mjs",
    "test:integration": "yarn g:vitest run -c vitest.config.integ.mts",
    "test:integration:watch": "yarn g:vitest watch -c vitest.config.integ.mts",
    "test:watch": "yarn g:vitest watch"
  },
  "main": "./dist-cjs/index.js",
  "types": "./dist-types/index.d.ts",
  "module": "./dist-es/index.js",
  "sideEffects": false,
  "dependencies": {
    "@aws-crypto/sha1-browser": "5.2.0",
    "@aws-crypto/sha256-browser": "5.2.0",
    "@aws-crypto/sha256-js": "5.2.0",
    "@aws-sdk/core": "^3.974.13",
    "@aws-sdk/credential-provider-node": "^3.972.44",
    "@aws-sdk/middleware-bucket-endpoint": "^3.972.15",
    "@aws-sdk/middleware-expect-continue": "^3.972.13",
    "@aws-sdk/middleware-flexible-checksums": "^3.974.21",
    "@aws-sdk/middleware-location-constraint": "^3.972.11",
    "@aws-sdk/middleware-sdk-s3": "^3.972.42",
    "@aws-sdk/middleware-ssec": "^3.972.11",
    "@aws-sdk/signature-v4-multi-region": "^3.996.28",
    "@aws-sdk/types": "^3.973.9",
    "@smithy/core": "^3.24.3",
    "@smithy/fetch-http-handler": "^5.4.3",
    "@smithy/node-http-handler": "^4.7.3",
    "@smithy/types": "^4.14.2",
    "tslib": "^2.6.2"
  },
  "devDependencies": {
    "@aws-sdk/signature-v4-crt": "3.1053.0",
    "@smithy/snapshot-testing": "^2.1.3",
    "@tsconfig/node20": "20.1.8",
    "@types/node": "^20.14.8",
    "concurrently": "7.0.0",
    "downlevel-dts": "0.10.1",
    "premove": "4.0.0",
    "typescript": "~5.8.3",
    "vitest": "^4.0.17"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "typesVersions": {
    "<4.5": {
      "dist-types/*": [
        "dist-types/ts3.4/*"
      ]
    }
  },
  "files": [
    "dist-*/**"
  ],
  "author": {
    "name": "AWS SDK for JavaScript Team",
    "url": "https://aws.amazon.com/javascript/"
  },
  "license": "Apache-2.0",
  "browser": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.browser"
  },
  "react-native": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.native"
  },
  "homepage": "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-s3",
  "repository": {
    "type": "git",
    "url": "https://github.com/aws/aws-sdk-js-v3.git",
    "directory": "clients/client-s3"
  }
}
